<template>
  <div class="townShipRightModule">
    <div class="loadingScreenMod indexJust" v-if="loading">
      <loadingModule />
    </div>
    <div class="loadingScreenMod indexJust" v-if="!loading && cityArea.length <= 0">
      <noData />
    </div>
    <div class="townShipRightModule-title" v-if="!loading && cityArea.length > 0">
      <p>排名</p>
      <p>辖区名称</p>
      <p>养殖场/户数量</p>
    </div>
    <div class="townShipRightModule-box" v-if="!loading && cityArea.length > 0">
      <ul>
        <li v-for="(item, index) in cityArea" :key="index">
          <p :class="{ yellow: !index, gray: index === 1, red: index === 2 }">
            <span>{{ index + 1 }}</span>
          </p>
          <p>{{ item.areaName }}</p>
          <p>{{ item.farmCount }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getAreaFarmCount } from '@/api/zzry';
import loadingModule from '@/views/businessModule/loading1.vue';
import noData from '@/views/businessModule/noData.vue';
export default {
  // props: {
  //   useList: {
  //     type: Array,
  //     default: []
  //   },
  //   useColor: {
  //     type: String,
  //     default: ''
  //   }
  // },
  name: 'townShipRight',
  components: {
    loadingModule,
    noData
  },
  data() {
    return {
      useFlag: true,
      remainderFlag: false,
      cityArea: [],
      loading: false
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let zizhouuserInfo = JSON.parse(localStorage.getItem('zizhouuserInfo'));
      let deptId = zizhouuserInfo.authProvincesCityAreas; // 当前所属的区域id
      this.loading = true;
      let _params = {
        areaId: deptId,
        livestockType: zizhouuserInfo.livestockType
      };
      // 黄蒿界镇
      if (deptId === '42303') {
        _params.livestockType = 4;
      }
      getAreaFarmCount(_params)
        .then(res => {
          this.loading = false;
          this.cityArea = res.data.data || [];
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
p {
  margin-block-start: 0;
  margin-block-end: 0;
}
.loadingScreenMod {
  height: 100%;
}
.townShipRightModule {
  background: rgba(31, 43, 55, 0.4);
  width: 100%;
  height: 100%;
  font-size: 0.7vw;
  // font-family: Regular;
  font-weight: 400;
  color: #1d5fd1;
  &-title,
  &-box {
    p {
      &:first-of-type {
        width: 3.15vw;
        padding-left: 0.8vw;
      }
      &:nth-of-type(2) {
        flex: 1;
      }
      &:last-of-type {
        width: 6.3vw;
      }
    }
  }
  &-title {
    height: 1.785vw;
    line-height: 1.785vw;
    background: rgba(29, 95, 209, 0.2);
    display: flex;
  }
  &-box {
    height: calc(100% - 1.785vw);
    overflow-y: scroll;
    margin-block-start: 0;
    margin-block-end: 0;
    p {
      &:first-of-type {
        span {
          padding: 0 0.42vw;
          display: inline;
        }
      }
      &.yellow {
        span {
          background: linear-gradient(left, rgba(232, 199, 32, 0) 0%, rgba(190, 127, 19, 1) 70%, rgba(232, 199, 32, 0) 100%);
        }
      }
      &.gray {
        span {
          background: linear-gradient(left, rgba(118, 121, 126, 0) 0%, rgba(118, 121, 126, 1) 70%, rgba(118, 121, 126, 0) 100%);
        }
      }
      &.red {
        span {
          background: linear-gradient(left, rgba(234, 100, 102, 0) 0%, rgba(234, 100, 102, 1) 70%, rgba(234, 100, 102, 0) 100%);
        }
      }
    }
  }
  &-box::-webkit-scrollbar {
    display: none;
  }
  li {
    height: 1.838vw;
    line-height: 1.838vw;
    display: flex;
    color: #fff;
  }
  li:nth-child(even) {
    background: #0f2650;
  }
}

.indexJust {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/townShipRight.vue